import { defineComponent as E, ref as x, watchEffect as L, nextTick as $, computed as C, openBlock as p, createElementBlock as k, createVNode as c, unref as u, withCtx as f, createElementVNode as m, normalizeClass as s, normalizeStyle as _, createBlock as F, Fragment as K, renderList as R, toDisplayString as T, createCommentVNode as q } from "vue";
import P from "./index60.js";
import { Combobox as Q, ComboboxInput as U, ComboboxButton as j, ComboboxOptions as A, ComboboxOption as G } from "./index269.js";
const H = { class: "base-combobox-wrapper relative w-full" }, J = { class: "relative w-full" }, W = { class: "block truncate" }, ee = /* @__PURE__ */ E({
  __name: "BaseComboBox",
  props: {
    modelValue: { default: void 0 },
    options: { default: () => [] },
    size: { default: "sm" },
    disabled: { type: Boolean, default: !1 },
    allowFreeInput: { type: Boolean, default: !1 },
    min: { default: void 0 },
    max: { default: void 0 },
    placeholder: { default: "선택하세요" },
    variant: { default: "default" }
  },
  emits: ["update:modelValue", "blur", "open-change"],
  setup(d, { emit: N }) {
    const t = d, l = N, r = x(""), i = x(!1), v = x(null), B = () => {
      i.value = !1, l("open-change", !1), I();
    };
    L(async () => {
      const e = v.value;
      if (await $(), e) {
        const a = e.offsetParent !== null;
        a !== i.value && (i.value = a, l("open-change", a));
      } else i.value && (i.value = !1, l("open-change", !1));
    });
    const b = (e) => (t.min !== void 0 && (e = Math.max(e, t.min)), t.max !== void 0 && (e = Math.min(e, t.max)), e), h = (e) => {
      if (!Number.isFinite(e))
        return e.toString();
      const a = Math.round(e);
      return Math.abs(e - a) < 1e-10 ? a.toString() : e.toFixed(10).replace(/\.?0+$/, "");
    }, g = C({
      get() {
        if (t.modelValue == null) return null;
        const e = t.options?.find((a) => {
          const o = parseFloat(a.value);
          return Math.abs(o - t.modelValue) < 1e-10;
        });
        if (e) {
          const a = parseFloat(e.value);
          return {
            ...e,
            label: h(a)
          };
        }
        return {
          value: t.modelValue.toString(),
          label: h(t.modelValue)
        };
      },
      set(e) {
        if (e) {
          const a = parseFloat(e.value);
          Number.isNaN(a) || (l("update:modelValue", b(a)), r.value = "");
        } else
          l("update:modelValue", void 0), r.value = "";
      }
    }), w = C(() => {
      if (!t.options?.length || !r.value) return t.options || [];
      const e = r.value.toLowerCase();
      return t.options.filter(
        (a) => a.label.toLowerCase().includes(e) || a.value.toLowerCase().includes(e)
      );
    }), y = () => {
      if (t.modelValue == null) return;
      const e = b(t.modelValue);
      e !== t.modelValue && (l("update:modelValue", e), r.value = "");
    }, z = (e) => {
      const a = e.target.value;
      if (r.value = a, !t.allowFreeInput) return;
      if (a === "") {
        l("update:modelValue", void 0), r.value = "";
        return;
      }
      const o = parseFloat(a);
      Number.isNaN(o) || l("update:modelValue", b(o));
    }, O = (e) => {
      e.key === "Enter" && t.allowFreeInput && (e.preventDefault(), setTimeout(() => {
        y(), e.target.blur();
      }, 0));
    }, V = () => {
      t.allowFreeInput && y(), l("blur");
    }, I = () => {
      V();
    }, M = (e) => e?.label || "";
    return (e, a) => (p(), k("div", H, [
      c(u(Q), {
        modelValue: g.value,
        "onUpdate:modelValue": a[0] || (a[0] = (o) => g.value = o),
        disabled: d.disabled,
        nullable: "",
        onClose: B
      }, {
        default: f(({ open: o }) => [
          m("div", J, [
            m("div", {
              class: s([
                "relative flex w-full overflow-hidden rounded-md border border-solid bg-[var(--input-color-surface)] transition-all duration-150",
                t.disabled ? "border-input-border-disabled text-input-text-disable cursor-not-allowed !bg-[var(--base-colors-neutral-neutral200)]" : t.variant === "compact" ? "border-input-border-static hover:border-input-border-static focus-within:border-input-border-static focus-within:shadow-none" : "border-input-border-static focus-within:border-input-border-focus hover:border-input-border-focus focus-within:shadow-[0_0_0_1px_var(--input-color-border-focus)]",
                t.variant === "compact" ? "h-[24px] rounded-[4px] px-[10px] text-[12px] leading-[14px] focus-within:shadow-none" : t.size === "sm" ? "h-[36px] px-[15px] text-[14px] leading-[16px]" : "h-[42px] px-[15px] text-[16px] leading-[20px]"
              ])
            }, [
              c(u(U), {
                "display-value": M,
                autocomplete: "off",
                class: s([
                  "w-full border-0 bg-transparent tracking-[-0.35px] outline-none",
                  t.variant === "compact" ? "px-0 py-[4px] pr-[16px] text-[12px] leading-[14px]" : t.size === "sm" ? "px-0 py-[13px] pr-[45px] text-[13px] leading-[16px]" : "px-0 py-[13px] pr-[45px] text-[16px] leading-[20px]",
                  t.disabled ? "text-input-text-disable placeholder:text-input-text-disable cursor-not-allowed" : "text-input-text-static placeholder:text-input-text-placeholder placeholder:font-normal placeholder:tracking-[-0.35px]"
                ]),
                style: _(
                  t.disabled ? "color: var(--font-color-default-muted-dark) !important; opacity: 1;" : ""
                ),
                placeholder: d.placeholder,
                onChange: z,
                onKeydown: O,
                onBlur: V
              }, null, 8, ["class", "style", "placeholder"]),
              c(u(j), {
                class: s([
                  "absolute right-0 top-0 flex h-full items-center",
                  t.variant === "compact" ? "pr-[8px]" : "pr-[15px]",
                  t.disabled ? "bg-input-bg-disabled cursor-not-allowed" : "cursor-pointer"
                ]),
                style: _(
                  t.disabled ? "color: var(--font-color-default-muted-dark) !important; opacity: 1;" : ""
                )
              }, {
                default: f(() => [
                  c(P, {
                    name: "arrow-down",
                    size: t.variant === "compact" || d.size === "sm" ? "sm" : "md",
                    color: d.disabled ? "disabled" : "default",
                    class: s(`transition-transform duration-200 ${o ? "rotate-180" : ""}`)
                  }, null, 8, ["size", "color", "class"])
                ]),
                _: 2
              }, 1032, ["class", "style"])
            ], 2),
            w.value.length > 0 ? (p(), F(u(A), {
              key: 0,
              ref_key: "optionsRef",
              ref: v,
              class: s([
                "border-input-border-static absolute z-[1350] mt-0 max-h-60 w-full overflow-auto rounded-md border bg-[var(--input-color-surface)] shadow-lg",
                t.variant === "compact" ? "py-0.5" : "py-1"
              ])
            }, {
              default: f(() => [
                (p(!0), k(K, null, R(w.value, (n) => (p(), F(u(G), {
                  key: n.value,
                  value: n,
                  disabled: n.disabled
                }, {
                  default: f(({ active: S, selected: D }) => [
                    m("li", {
                      class: s([
                        "relative cursor-default select-none tracking-[-0.35px]",
                        t.variant === "compact" ? "py-1 pl-2 pr-3 text-[12px] leading-[14px]" : "py-2 pl-3 pr-9 text-[13px] leading-[16px]",
                        n.disabled ? "text-input-text-disable cursor-not-allowed opacity-50" : S ? "text-input-text-static bg-[var(--background-bg-surface-muted)]" : "text-input-text-static",
                        D && !n.disabled ? "font-medium" : ""
                      ])
                    }, [
                      m("span", W, T(n.label), 1)
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["value", "disabled"]))), 128))
              ]),
              _: 1
            }, 8, ["class"])) : q("", !0)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ]));
  }
});
export {
  ee as default
};
